import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || "#fff"}; /* white button background */
  color: ${(p) => (p.color ? "#fff" : "#000")}; /* black text by default */
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid ${(p) => (p.color ? "#fff" : "#fff")}; /* white border */
  border-radius: 4px;
  padding: 13px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);

  &:hover,
  &:active,
  &:focus {
    color: #fff; /* text turns white on hover */
    border: 1px solid #b3b3b3; /* light gray border on hover */
    background-color: #000; /* black background on hover */
  }
`;